import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Лавлагаа")
const _hoisted_5 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "card card-stretch shadow mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Энгийн хайлт")
  ])
], -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "col-md-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хуулийн статус:", -1)
const _hoisted_12 = { style: {"float":"left"} }
const _hoisted_13 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "col-md-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх талбар:", -1)
const _hoisted_17 = { style: {"float":"left"} }
const _hoisted_18 = { style: {"float":"left"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-md-10 demo-input-suffix" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх утга:", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "card-footer" }
const _hoisted_24 = ["data-kt-indicator"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Хайх ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "col-lg-6" }
const _hoisted_29 = { class: "card shadow mb-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Хамтран зээлдэгч")
  ])
], -1)
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "col-md-10" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Холбогдох статус:", -1)
const _hoisted_34 = { style: {"float":"left"} }
const _hoisted_35 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = { class: "col-md-10" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх талбар:", -1)
const _hoisted_39 = { style: {"float":"left"} }
const _hoisted_40 = { style: {"float":"left"} }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { class: "col-md-10 demo-input-suffix" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх утга:", -1)
const _hoisted_44 = { class: "card-footer" }
const _hoisted_45 = ["data-kt-indicator"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Хайх ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "card shadow"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Хайлтын үр дүн")
  ])
], -1)
const _hoisted_51 = {
  class: "card-body",
  style: {"padding":"0"}
}
const _hoisted_52 = {
  key: 0,
  class: "table table-rounded table-striped border gy-3 gs-3"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    align: "center",
    class: "fw-bold fs-5 fw-bolder border-bottom border-gray-400 fs-4"
  }, [
    /*#__PURE__*/_createElementVNode("th", { colspan: 2 }, " Доорх утганд тохирох зээлдэгчийн мэдээлэл олдсонгүй. ")
  ])
], -1)
const _hoisted_54 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, "Хуулийн статус:", -1)
const _hoisted_56 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", null, "Харгалзах хайх талбар:", -1)
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", null, "Хайсан утга:", -1)
const _hoisted_62 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", null, "Хайсан огноо:", -1)
const _hoisted_64 = {
  key: 1,
  class: "table table-rounded table-striped border gy-3 gs-3"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    align: "center",
    class: "fw-bold fs-5 fw-bolder border-bottom border-gray-400 fs-4"
  }, [
    /*#__PURE__*/_createElementVNode("th", { colspan: 2 }, " Доорх утганд тохирох хамтран зээлдэгчийн мэдээлэл олдсонгүй. ")
  ])
], -1)
const _hoisted_66 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", null, "Хуулийн статус:", -1)
const _hoisted_68 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, "Харгалзах хайх талбар:", -1)
const _hoisted_70 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, "Хайсан утга:", -1)
const _hoisted_72 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", null, "Хайсан огноо:", -1)
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (
      // this.role.includes('ROLE_ADMIN') || this.role.includes('ROLE_GET_INQUIRY')
      this.role.includes('ROLE_ADMIN') || this.role.includes('ROLE_NEW_USER')
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_el_select, {
                    id: "legalStatusSelect",
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
                    class: "col-md-7",
                    onChange: _ctx.resetResultFieldsLegalStatus,
                    placeholder: "Хуулийн статус"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legalStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.label), 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(item.value), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.val,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.val) = $event)),
                    class: "col-md-7",
                    placeholder: "Select",
                    onChange: _ctx.resetResultFields
                  }, {
                    default: _withCtx(() => [
                      (_ctx.value === '01' || _ctx.value === '02')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.citizenFields, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.val,
                              label: item.label,
                              value: item.val
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.orgFields, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.val,
                              label: item.label,
                              value: item.val
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_el_input, {
                    id: "searchValueSimple",
                    onKeyup: _withKeys(_ctx.getCustomerReference, ["enter"]),
                    modelValue: _ctx.searchValue,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchValue) = $event)),
                    class: "col-md-7",
                    placeholder: "Хайх утга"
                  }, null, 8, ["onKeyup", "modelValue"])
                ]),
                _hoisted_22
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "el-button el-button--primary el-button--mini col-lg-4",
                  size: "mini",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getCustomerReference && _ctx.getCustomerReference(...args))),
                  "data-kt-indicator": this.loadButtonSimple
                }, _hoisted_27, 8, _hoisted_24)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.coValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.coValue) = $event)),
                    class: "col-md-7",
                    onChange: _ctx.resetResultFieldsCoLegalStatus,
                    placeholder: "Хуулийн статус"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.coValue,
                          label: item.coLabel,
                          value: item.coValue
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(item.coLabel), 1),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(item.coValue), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.coVal,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.coVal) = $event)),
                    class: "col-md-7",
                    placeholder: "Select",
                    onChange: _ctx.resetResultFields
                  }, {
                    default: _withCtx(() => [
                      (_ctx.coValue === '01')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.coFieldsCitizen, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.coVal,
                              label: item.coLabel,
                              value: item.coVal
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_39, _toDisplayString(item.coLabel), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.coFieldsOrg, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.coVal,
                              label: item.coLabel,
                              value: item.coVal
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_40, _toDisplayString(item.coLabel), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_el_input, {
                    id: "searchValueRel",
                    onKeyup: _withKeys(_ctx.getCoCustomerReference, ["enter"]),
                    modelValue: _ctx.coSearchValue,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.coSearchValue) = $event)),
                    class: "col-md-7",
                    placeholder: "Хайх утга"
                  }, null, 8, ["onKeyup", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  class: "el-button el-button--primary el-button--mini col-lg-4",
                  size: "mini",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getCoCustomerReference && _ctx.getCoCustomerReference(...args))),
                  "data-kt-indicator": this.loadButtonSimple
                }, _hoisted_48, 8, _hoisted_45)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (this.loadButtonSimple === 'on')
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5,
          animated: ""
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.result)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  (_ctx.customerResultCode === 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", _hoisted_54, [
                            _hoisted_55,
                            _createElementVNode("td", null, _toDisplayString(this.legalStatus.find(item => {
                    return this.value === item.value;
                  })?.label), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_56, [
                            _hoisted_57,
                            (this.value === '01' || this.value === '02')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(this.citizenFields.find(item => {
                    return this.val === item.val;
                  })?.label), 1))
                              : (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(this.orgFields.find(item => {
                    return this.val === item.val;
                  })?.label), 1))
                          ]),
                          _createElementVNode("tr", _hoisted_60, [
                            _hoisted_61,
                            _createElementVNode("td", null, _toDisplayString(this.searchedValue), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_62, [
                            _hoisted_63,
                            _createElementVNode("td", null, _toDisplayString(_ctx.getMomentTime(Date.now())), 1)
                          ])
                        ])
                      ]))
                    : (_ctx.coRelResultCode === 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("td", null, _toDisplayString(this.coStatus.find(item => {
                    return this.coValue === item.coValue;
                  })?.coLabel), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_68, [
                              _hoisted_69,
                              _createElementVNode("td", null, _toDisplayString(this.coValue === "01" ?
                    this.coFieldsCitizen.find(item => {
                      return this.coVal === item.coVal;
                    })?.coLabel
                    :
                    this.coFieldsOrg.find(item => {
                      return this.coVal === item.coVal;
                    })?.coLabel), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_70, [
                              _hoisted_71,
                              _createElementVNode("td", null, _toDisplayString(this.searchedValue), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("td", null, _toDisplayString(_ctx.getMomentTime(Date.now())), 1)
                            ])
                          ])
                        ]))
                      : (_ctx.customerResultCode !== 0 && _ctx.customerResultCode !== -1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.value === '01' || _ctx.value === '02')
                              ? (_openBlock(), _createBlock(_component_el_table, {
                                  key: 0,
                                  data: _ctx.citizenTableData,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      label: "#",
                                      width: "80"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "Зээлдэгчийн регистрийн дугаар" }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("span", {
                                          class: "customized-link-span",
                                          onClick: ($event: any) => (
                      _ctx.getCustomerDetails(scope.row.identityno)
                    )
                                        }, _toDisplayString(scope.row.identityno), 9, _hoisted_74)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Овог",
                                      prop: "lastname"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Нэр",
                                      prop: "customername"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Регистрийн дугаар",
                                      prop: "registerno"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]))
                              : (_openBlock(), _createBlock(_component_el_table, {
                                  key: 1,
                                  data: _ctx.orgTableData,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      label: "#",
                                      prop: "date",
                                      width: "60"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "Зээлдэгчийн регистрийн дугаар" }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("span", {
                                          class: "customized-link-span",
                                          onClick: ($event: any) => (
                      _ctx.getCustomerDetails(scope.row.identityno)
                    )
                                        }, _toDisplayString(scope.row.identityno), 9, _hoisted_75)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Улсын бүртгэлийн дугаар",
                                      prop: "registerno"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Байгууллагын нэр",
                                      prop: "customername"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Захирлын cin",
                                      prop: "ceocivilid"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Захирлын овог",
                                      prop: "ceolastname"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Захирлын нэр",
                                      prop: "ceofirstname"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]))
                          ], 64))
                        : (_ctx.coRelResultCode !== 0 && _ctx.coRelResultCode !== -1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (_ctx.coValue === '01')
                                ? (_openBlock(), _createBlock(_component_el_table, {
                                    key: 0,
                                    data: _ctx.coRelCitizenTableData,
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, {
                                        label: "#",
                                        width: "80"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, { label: "Үндсэн зээлдэгчийн CIN" }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", {
                                            class: "customized-link-span",
                                            onClick: ($event: any) => (_ctx.getCustomerDetails(scope.row.identityno))
                                          }, _toDisplayString(scope.row.identityno), 9, _hoisted_76)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Үндсэн зээлдэгчийн нэр",
                                        prop: "customername"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдогчийн CIN",
                                        prop: "relidentityno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдогчийн регистерийн №",
                                        prop: "relregisterno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдогчийн овог",
                                        prop: "rellastname"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдогчийн нэр",
                                        prop: "relsubjectname"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["data"]))
                                : (_openBlock(), _createBlock(_component_el_table, {
                                    key: 1,
                                    data: _ctx.coRelOrgTableData,
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, {
                                        label: "#",
                                        prop: "date",
                                        width: "60"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, { label: "Үндсэн зээлдэгчийн код" }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", {
                                            class: "customized-link-span",
                                            onClick: ($event: any) => (_ctx.getCustomerDetails(scope.row.identityno))
                                          }, _toDisplayString(scope.row.identityno), 9, _hoisted_77)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Үндсэн зээлдэгчийн нэр",
                                        prop: "customername"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдогчийн регистерийн №",
                                        prop: "relidentityno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдогчийн УБ дугаар",
                                        prop: "relregisterno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдогчийн нэр",
                                        prop: "relsubjectname"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["data"]))
                            ], 64))
                          : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 64))
}